import React from "react";

function Total(props) {
  return <div className="navbar footer">Total : {props.total}</div>;
}
export default Total;
